import React from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import "./Modal.scss";

const CustomModal = ({
  show,
  handleClose,
  className,
  size,
  closeButton = true,
  children,
  display = "",
  fullscreen = false,
}) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size={size}
        centered
        className={`custom_modal ${className}`}
        backdrop={display}
        fullscreen={fullscreen}
      >
        <Modal.Body>
          {closeButton && (
            <span className="close_button" onClick={handleClose}>
              <IoClose />
            </span>
          )}
          <div className="modal_content">{children}</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomModal;
